export default {"src":"/_next/static/media/pie_chart.a20451fc.svg","height":155,"width":155,"blurWidth":0,"blurHeight":0};